import { useQuery } from '@tanstack/react-query';
import { getNotifications } from '../api/notifications';

/**
 * Polls the reviewer/admin notification feed (backlog C2) — escalations + closes
 * ready to review across clients. Derived/actionable, so a short poll keeps the
 * unread count fresh.
 */
export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
